import React, { ReactElement } from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';

import { PhoneInputWrapperStyled } from './phone-input.styled';

import 'react-phone-input-2/lib/material.css';

interface IProps extends PhoneInputProps {
  required?: boolean;
}

export const JPhoneInput: React.FC<IProps> = ({
  required,
  specialLabel,
  ...props
}): ReactElement => {
  return (
    <PhoneInputWrapperStyled required={required}>
      <PhoneInput
        specialLabel={specialLabel}
        {...props}
        country="fr"
        inputProps={{ 'data-qa': `input-phone-${specialLabel ?? 'default'}` }}
      />
    </PhoneInputWrapperStyled>
  );
};
